import React from 'react'
import { connect } from 'react-redux'
import PieChart from 'react-minimal-pie-chart'
import MenuIcon from 'react-icons/lib/md/menu'
import { getSurveyProgress } from '../selectors.js'
import IconButton from './IconButton.js'
import './QuestionMenu.css'

const COLOR_UNANSWERED = '#fff'
const COLOR_HAS_ANSWER = '#51d1ad'
const COLOR_CURRENT_QUESTION = '#5ce8c1'

const QuestionMenu = ({ progress, onMenuClick }) => {
  const chartData = progress
    .map(({ questionId, isCurrentQuestion, hasAnswer }) => ({
      value: 1,
      color: getSliceColor({ isCurrentQuestion, hasAnswer }),
    }))
    .reverse()

  return (
    <div className="QuestionMenu">
      <div className="menu-button-wrap">
        <IconButton onClick={onMenuClick}>
          <MenuIcon size={24} />
        </IconButton>
      </div>

      <div className="pie-wrap">
        <PieChart
          startAngle={0}
          lineWidth={20}
          animate={false}
          rounded={true}
          lengthAngle={-180}
          data={chartData}
        />
      </div>
    </div>
  )
}

function getSliceColor({ isCurrentQuestion, hasAnswer }) {
  if (isCurrentQuestion) return COLOR_CURRENT_QUESTION
  if (hasAnswer) return COLOR_HAS_ANSWER
  return COLOR_UNANSWERED
}

const mapStateToProps = state => ({
  progress: getSurveyProgress(state),
})

const mapDispatchToProps = ({ isMenuOpen: { toggle } }) => ({
  onMenuClick: () => toggle(),
})

export default connect(mapStateToProps, mapDispatchToProps)(QuestionMenu)



// WEBPACK FOOTER //
// ./src/components/QuestionMenu.js